module.exports = __webpack_public_path__ + "static/media/Study_Files.961d7940.svg";